<template>
    <div class="vc-header-right">
        <div v-if="showMarketscopeLabel" class="vc-header-right-divider vc-header-right-marketscope">
            <KatFlag class="vc-header-right-marketscope-flag" :country="marketscope" />
            {{ marketscopeLabel }}
        </div>
        <TheLanguageSwitcher v-if="site !== Site.ADVANTAGE" class="vc-header-right-divider" />
        <a id="help-hub-landing-page_topNav" class="vc-header-right-divider" :href="helpUrl">
            {{ $t('header_center_support') }}
        </a>
        <a v-if="isLoggedIn || errorMessage" :id="logoutId" class="vc-header-right-divider" :href="SIGN_OUT_URL">
            {{ $t('header_right_signOut') }}
        </a>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import { HELP_URL, HELP_URL_LEGACY, SIGN_OUT_URL } from '../constants/urls';
import { useContextStore } from '../stores/contextStore';
import KatFlag from './katal/KatFlag.vue';
import TheLanguageSwitcher from './TheLanguageSwitcher.vue';
import { Site } from '../enums/Site';

export default {
    name: 'TheHeaderRight',
    components: { KatFlag, TheLanguageSwitcher },
    data: function () {
        return {
            SIGN_OUT_URL,
            Site,
        };
    },
    computed: {
        ...mapState(useContextStore, [
            'errorMessage',
            'site',
            'businessName',
            'marketscope',
            'customerId',
            'vendorCodes',
        ]),
        helpUrl() {
            return this.site === Site.ADVANTAGE ? HELP_URL_LEGACY : HELP_URL;
        },
        marketscopeLabel() {
            const businessNameSegment = this.businessName ? ` - ${this.businessName}` : '';
            const vendorCodeSegment =
                this.site === Site.ADVANTAGE && this.vendorCodes?.length ? ` | ${this.vendorCodes[0]}` : '';
            return this.marketscope + businessNameSegment + vendorCodeSegment;
        },
        isLoggedIn() {
            return this.customerId;
        },
        showMarketscopeLabel() {
            return (this.businessName || this.marketscope || this.vendorCodes) && this.isLoggedIn;
        },
        logoutId() {
            // The id 'vc-header-logout' is being used by SPX and SPP for integration/canary tests.
            // This id should not be changed; otherwise, inform SPX and SPP to update their integration/canary tests.
            // See https://sim.amazon.com/issues/SPX-2705.
            return 'vc-header-logout';
        },
    },
};
</script>

<style lang="scss" scoped>
.vc-header-right {
    align-items: center;
    display: flex;

    &-divider {
        border-right: 1px solid #ddd;
        padding: 0 8px;

        &:last-child {
            border-right: unset;
        }
    }

    .ico-mglass {
        border: 2px solid rgb(0 0 0);
        border-radius: 30px;
        box-sizing: content-box !important;
        display: inline-block;
        height: 6px;
        margin-bottom: 5px;
        margin-left: 10px;
        position: relative;
        width: 6px;

        &::after {
            background: rgb(0 0 0);
            content: '';
            height: 2px;
            left: 5px;
            position: absolute;
            top: 7px;
            transform: rotate(45deg);
            width: 6px;
        }
    }

    &-marketscope {
        align-items: center;
        display: flex;
        font-size: 12px;
        line-height: 16px;

        &-flag {
            flex: 0 0 auto;
            margin-right: 8px;
        }
    }
}
</style>
